module.exports = __webpack_public_path__ + "ebc2af2a6da81f7b9cafc3c4d5db46fc.svg";